import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

export function retryWhenNot401<T>(
  maxRetries = 3,
  delayMs = 50
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => {
    return source.pipe(
      retry({
        delay: (error, retryCount) => {
          let rv;
          if (error instanceof HttpErrorResponse && error.status === 401) {
            // Si el error es 401, no reintentar
            rv = throwError(() => error);
          } else if (retryCount < maxRetries) {
            // Reintentar hasta el número máximo de veces especificado
            // Esperar el tiempo especificado antes de reintentar
            rv = timer(delayMs * retryCount * retryCount);
          } else {
            // Si se supera el número máximo de reintentos, propagar el error
            rv = throwError(() => error);
          }

          return rv;
        },
      })
    );
  };
}
